export interface IResponse {
    status: number;
    json?: any;
    error?: any;
    message?: string;
}

const getLocalizeMessage = async ({response, lang}: {response: IResponse, lang?: string,}): Promise<string> => {
    try {
        let err = lang === 'ru' ? 'Повторите попытку позже.' : 'Please try again later.';

        if (typeof response.json !== 'undefined') {
            const errJson = await response.json();
            
            err = (errJson && (errJson.error?.message || errJson.message)) ?? err;
        } else if (response.error?.message || response.message) {
            err = (response.error?.message || response.message) ?? err;
        }

        if (lang !== 'ru') {
            return `An error has occurred. ${typeof response.status !== 'undefined' ? 'Server response ('+response.status+').' : ''} ${err}`;
        }

        return `Произошла ошибка. ${typeof response.status !== 'undefined' ? 'Ответ сервера ('+response.status+').' : ''} ${err}`;   
    } catch (error) {
        throw new Error('Ошибка');
    }
}

const errorChecker = async (response: IResponse, lang = 'ru'): Promise<any> => {
    const { status } = response;
    
    if ((status && status >= 400 && status < 500) || Object.prototype.hasOwnProperty.call(response, 'error')) {
        
        const message = await getLocalizeMessage({response, lang});
        alert(message);
        return Promise.reject(message);
    }

    return Promise.resolve(true);
} 

export default errorChecker;
